import React from "react";

export const IconsLayerIcon = () => (
  <svg width="16" height="16" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.1006" cy="12.7705" r="9" stroke="#0C172C" strokeWidth="2" fill="none" />
    <path
      d="M9.10059 15.7705C9.10059 15.7705 10.6006 16.7705 12.1006 16.7705C13.6006 16.7705 15.1006 15.7705 15.1006 15.7705"
      stroke="#0C172C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M9.60059 10.2705V12.7705" stroke="#0C172C" strokeWidth="2" strokeLinecap="round" />
    <path d="M14.6006 10.2705V12.7705" stroke="#0C172C" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
